import { StylesIndexInjections } from 'common-react';
import { createStyles, makeUiStyles, Theme } from '../styles/styles';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      padding: 80,
    },
  },
  title: {
    padding: '16px 0 24px 0'
  },
  description: {
    paddingBottom: 24,
  },
}), { name: 'EmptyFiltersCard', index: StylesIndexInjections.UI_MOLECULES });
